import { render, staticRenderFns } from "./PastBizDayTrans.vue?vue&type=template&id=f0737fe2&"
import script from "./PastBizDayTrans.vue?vue&type=script&lang=js&"
export * from "./PastBizDayTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports